import { useCallback } from 'react'
import { useAuth } from '@wehunt/core-web'
import { apiFetch, type ApiFetchInit } from './apiFetch'

export function useApiFetch() {
  const { state } = useAuth()
  return useCallback(
    async function call<T>(path: string, init?: Omit<ApiFetchInit, 'token'>): Promise<T> {
      if (state.status !== 'signed-in') throw new Error('Not signed in')
      const token = await state.user.getIdToken()
      return apiFetch<T>(path, { ...init, token })
    },
    [state],
  )
}
